import { useQuery } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planQueryKeys } from '../constants'

export const useGetPlanDetailsQuery = (planId, options) => {
  const handleQuery = async () => {
    const config = {
      method: 'get'
    }
    const { data } = await api(`/api/v2/plans/${planId}`, config)

    return data
  }

  return useQuery({
    queryKey: [planQueryKeys.GET_PLAN_DETAILS, planId],
    queryFn: handleQuery,
    enabled: !!planId,
    retry: 0,
    ...options
  })
}
